import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import { isAuthenticated } from '../../common/utils';
import "./notFound.scss";

const NotFound = () => {
  const navigate = useNavigate();
  const isUserAuthenticated = isAuthenticated();
  const handleRedirect = () => {
     if (isUserAuthenticated) {
      navigate('/dashboard');
    } else {
      navigate('/login');
    }
  };

  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <h1 className="error-code">404</h1>
        <p className="error-message">Page Not Found</p>
        <p className="error-description">
           Sorry, the page you are looking for could not be found.
        </p>
        <Button onClick={handleRedirect} variant="primary" size="lg">
          {isUserAuthenticated ? 'Go to Dashboard' : 'Go to Login'}
        </Button>
      </div>
    </div>
  );
};

export default NotFound;
